export const getUserEndpoint = (_id:string) => `user?_id=${_id}`;